export default "__VITE_ASSET__ttjc2xaB__"